import Alert from 'react-bootstrap/Alert';
import React, { useState, useEffect } from 'react';
import GoalService from './GoalService';

import { Button, Card, Col, Row } from 'react-bootstrap';
import filterFieldsForList from '../common/functions/filterFieldsForList';
import filterDataForList from '../common/functions/filterDataForList';
import schema from './goalSchema';
import performanceSchema from './jsonSchema';
import ProgressBarWidget from '../common/functions/ProgressBarWidget';
import AdvanceList from '../common/AdvanceList';
import PerformanceReviewService from './PerformanceReviewService';
import useHeaderGenerator from '../common/functions/useHeaderGenerator';
import { useNavigate } from 'react-router-dom';
import DemoService from '../common/functions/DemoService';
import FeedbackList from './FeedbackList';
import { Link } from 'react-router-dom';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
import useButtonsGenerator from '../common/functions/useButtonsGenerator';
import IconButton from 'components/common/IconButton';

const PerformanceManagementLandingPage = () => {
  const [data, setData] = useState();
  const [reviewData, setReviewData] = useState();
  const [columns, setColumns] = useState([]);
  const [reviewColumns, setReviewColumns] = useState([]);
  const [error, setError] = useState('');
  const [noGoalDataToShow, setNoGoalDataToShow] = useState(true);
  const [noReviewsDataToShow, setNoReviewsDataToShow] = useState(true);
  const [progressBarData, setProgressBarData] = useState();
  const navigate = useNavigate();
  const transformGoalDataFunction = (attr, item) => {
    console.log(attr);
    if (attr == 'name') {
      const url = '/app/performance/goal/' + item['identifier'] + '/edit';
      return <a href={url}>{item[attr]}</a>;
    }
    if (attr === 'deadline') {
      return convertTime(item[attr]);
    }
    return item[attr];
  };
  const convertTime = time => {
    const [year, month, day] = time.split('-').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day, 12));
    return date.toLocaleDateString();
  };
  const transformReviewsDataFunction = (attr, item) => {
    console.log(attr);
    if (attr == 'reviewer') {
      const url = '/app/performance/' + item['identifier'] + '/edit';
      return <a href={url}>{item[attr]}</a>;
    }
    return item[attr];
  };
  useEffect(() => {
    const jsonSchema = schema;
    const fieldsForList = filterFieldsForList(jsonSchema);

    setColumns(fieldsForList);

    const reviewFieldsForList = [
      {
        accessor: 'employee',
        Header: 'Employee',
        headerProps: { className: 'pe-1' },
        cellProps: {
          className: 'py-2'
        },
        Cell: rowData => {
          const { employee, employeeAvatar, identifier } = rowData.row.original;
          const link = '/app/performance/' + identifier + '/edit';
          return (
            <Link to={link}>
              <Flex alignItems="center">
                {employeeAvatar ? (
                  <Avatar src={employeeAvatar} size="xl" className="me-3" />
                ) : (
                  <Avatar size="xl" name={employeeAvatar} className="me-3" />
                )}
                <div className="flex-1">
                  <h5 className="mb-0 fs--1">{employee}</h5>
                </div>
              </Flex>
            </Link>
          );
        }
      },
      { accessor: 'reviewer', Header: 'Reviewer' },
      { accessor: 'reviewDate', Header: 'Review Date' }
    ];
    setReviewColumns(reviewFieldsForList);
    const demoGoals = DemoService.retrieveDemoGoals().map(goal => ({
      deadline: goal.deadline,
      description: goal.description,
      identifier: goal.identifier,
      name: goal.name,
      profileIdentifier: goal.profileIdentifier,
      progress: goal.progress,
      targetValue: goal.targetValue
    }));
    const demoReviews = DemoService.retrieveDemoReviews();
    PerformanceReviewService.retrieveAllPerformanceReviewByProfile()
      .then(data => {
        if (localStorage.getItem('bstDemoMode') === 'true') {
          data.push(...demoReviews);
        }
        console.log('Reviews nuevo', data);

        setReviewData(data);
        setNoReviewsDataToShow(!data.length > 0);
      })
      .catch(error => setError({ error: error.message }));

    GoalService.retrieveAllGoalByAccount()
      .then(data => {
        if (localStorage.getItem('bstDemoMode') === 'true' || !data.length) {
          data.push(...demoGoals.slice(1, 7));
        }
        setData(
          filterDataForList(
            data,
            columns.map(c => c.accessor),
            transformGoalDataFunction
          )
        );
        setNoGoalDataToShow(!data.length > 0);
        const progressBarData = data.map(goal => ({
          name: goal.name,
          progress: goal.progress
        }));

        setProgressBarData(progressBarData);
      })
      .catch(error => setError({ error: error.message }));
  }, [noGoalDataToShow, noReviewsDataToShow]);
  const buttonsConf = [
    {
      name: 'Create a new Goal',
      type: 'submit',
      icon: 'plus',
      variant: 'info',
      onClick: () => {
        console.log('Create a new Goal');
        navigate('/app/performance/goal-form');
      }
    },
    {
      name: 'Upload a review',
      type: 'submit',
      variant: 'success',
      icon: 'plus',
      onClick: () => {
        console.log('Create a new review');
        navigate('/app/performance/create-form');
      }
    },
    {
      name: 'Request Feedback',
      type: 'submit',
      variant: 'success',
      icon: 'comments',
      onClick: () => {
        console.log('Request feedback');
        navigate('/app/performance/feedback-request-form');
      }
    }
  ];
  const buttons = useButtonsGenerator(buttonsConf);
  const performanceLandingPageDescription =
    'Enhance employee development with our dynamic Performance Management module. Set goals, conduct evaluations, and provide continuous feedback within an interactive and transparent system. This module supports personalized development plans and fosters a culture of growth and achievement, aligning individual performance with organizational objectives.';
  const headerGenerated = useHeaderGenerator(
    'Performance & Goals',
    performanceLandingPageDescription,
    buttonsConf
  );
  return (
    <>
      {headerGenerated}
      {error}
      <Row className="g-3 mb-3">
        <Col xxl={12}>
          {progressBarData && <ProgressBarWidget goals={progressBarData} />}
        </Col>
      </Row>
      <Row className="g-3 mb-3">
        <Col xxl={12}>
          <Card>
            <Card.Header>
              <h5 className="display-6 mb-0">Goals</h5>
            </Card.Header>
            <Card.Body>
              {noGoalDataToShow && (
                <Alert key="warning" variant="warning" className="fs--1">
                  There's not any Goal to show. Let's create a new one!
                </Alert>
              )}
              {data && (
                <>
                  <IconButton
                    icon={'plus'}
                    variant={'success'}
                    className={'btn btn-sm'}
                    onClick={() => {
                      navigate('/app/performance/goal-form');
                    }}
                  >
                    New Goal
                  </IconButton>
                  <AdvanceList
                    columns={columns}
                    data={data}
                    newObject={{
                      url: '/app/performance/goal-form',
                      title: 'Create a new goal'
                    }}
                  />
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="g-3 mb-3">
        <Col xxl={12}>
          <Card>
            <Card.Header>
              <h5 className="display-6 mb-0">Reviews</h5>
            </Card.Header>
            <Card.Body>
              {noReviewsDataToShow && (
                <Alert key="warning" variant="warning">
                  There's not any Reviews to show.
                  <Button
                    className={'btn btn-sm m-2'}
                    onClick={() => {
                      navigate('/app/performance/create-form');
                    }}
                  >
                    Let's create a new one!
                  </Button>
                </Alert>
              )}
              {!noReviewsDataToShow && (
                <AdvanceList
                  columns={reviewColumns}
                  data={reviewData}
                  newObject={{
                    url: '/app/performance/create-form',
                    title: 'Upload a Review'
                  }}
                />
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col xxl={12} className="mb-3">
          <Card id={'feedbacks'}>
            <Card.Header>
              <h5 className="display-6 mb-0">Feedbacks</h5>
            </Card.Header>
            <Card.Body>
              <FeedbackList></FeedbackList>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PerformanceManagementLandingPage;
